import { Message } from 'element-ui';

export const showLoading = (opt = { content: '执行操作中,请稍后..', delay: 0 }) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      Message({
        message: opt.content,
        duration: 0
      });
    }, opt.delay)
  })
}

export const hideLoading = (delay) => {
  if (delay) {
    setTimeout(() => {
      Message.closeAll()
    }, delay * 1000)
  } else Message.closeAll()
}

export default {
  showLoading,
  hideLoading
}



// WEBPACK FOOTER //
// ./src/cuview-ui/libs/function/loading.js